/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FieldOriginFromJSON, FieldOriginToJSON, } from './FieldOrigin';
import { SeverityFromJSON, SeverityToJSON, } from './Severity';
/**
 * Check if a given object implements the MetaDataItem interface.
 */
export function instanceOfMetaDataItem(value) {
    var isInstance = true;
    return isInstance;
}
export function MetaDataItemFromJSON(json) {
    return MetaDataItemFromJSONTyped(json, false);
}
export function MetaDataItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fieldOrigin': !exists(json, 'fieldOrigin') ? undefined : FieldOriginFromJSON(json['fieldOrigin']),
        'severity': !exists(json, 'severity') ? undefined : SeverityFromJSON(json['severity']),
        'errorType': !exists(json, 'errorType') ? undefined : json['errorType'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'errorDetail': !exists(json, 'errorDetail') ? undefined : json['errorDetail'],
        'fieldName': !exists(json, 'fieldName') ? undefined : json['fieldName']
    };
}
export function MetaDataItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fieldOrigin': FieldOriginToJSON(value.fieldOrigin),
        'severity': SeverityToJSON(value.severity),
        'errorType': value.errorType,
        'message': value.message,
        'errorDetail': value.errorDetail,
        'fieldName': value.fieldName
    };
}
